import React, {useEffect, useState} from "react";
import {AdminBannerBox} from "./boxes/admin-banner-wrapper.box";
import {observer} from "mobx-react";
import {ComponentServicesPick} from "../../services/component-services-pick";
import {withServices} from "../../react-hooks/with-services";
import {NullableString} from "../../../common/types/nullable-types";
import {Check} from "@sparkware/app-utils";


declare global {
    namespace JSX {
        interface IntrinsicElements {
            "banner-slider": any;
        }
    }
}

export interface AdminBannerComponentProps {
    bannerAdminPlaceholderId: string;
}
export interface AdminBannerComponentWithServicesProps extends ComponentServicesPick<'adminBanner' | 'user'>, AdminBannerComponentProps{

}

const ComponentBody:React.FC<AdminBannerComponentWithServicesProps> = observer((props) => {
    const [bannerSegmentation, setBannerSegmentation] = useState<NullableString>(null);

    useEffect(() => {
        props.adminBanner.getSegmentationsForAdminBanner().then(segmentation => {
            setBannerSegmentation(JSON.stringify(segmentation));
        })
    }, [props.adminBanner, props.user.isAuthorized]);

    if(Check.isNullOrUndefined(bannerSegmentation)) {
        return null;
    }

    const bannerConfig = JSON.stringify(props.adminBanner.getConfigForAdminBanner(props.bannerAdminPlaceholderId));
    return (
        <AdminBannerBox>
            <banner-slider
                config={bannerConfig}
                segmentation={bannerSegmentation}
            ></banner-slider>
        </AdminBannerBox>
    );
});

export const AdminBannerComponent = withServices(ComponentBody, ["adminBanner", "user"]);